import { render } from "./LoaderEllipsisComponent.vue?vue&type=template&id=37676136&scoped=true"
import script from "./LoaderEllipsisComponent.vue?vue&type=script&lang=js"
export * from "./LoaderEllipsisComponent.vue?vue&type=script&lang=js"

import "./LoaderEllipsisComponent.vue?vue&type=style&index=0&id=37676136&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37676136"]])

export default __exports__